import Button from '../atoms/Buttons'
import { useEffect } from 'react'
import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import LeftVectorIcon from '../../assets/icons/LeftVectorIcon.svg'
import TopVectorIcon from '../../assets/icons/TopVectorIcon.svg'
import './style.css'

export const PreviewBanner = ({
  bannerItem,
  isLoading,
  imageUrl,
  videoUrl,
  selectedPosition,
  overlayColor,
  imageObjectFit = 'cover',
  imageObjectPosition = 'center center',
  focalPanHandlers = null,
  focalPanDragging = false,
}) => {
  const { ref: textRef, inView: textInView } = useInView()
  const { ref: paraRef, inView: paraInView } = useInView()
  const { ref: buttonRef, inView: buttonInView } = useInView()

  const controls = useAnimation()
  const paraControls = useAnimation()
  const buttonControls = useAnimation()

  const position = selectedPosition ?? 'justify-start'
  const vectorSrc = position === 'justify-center' ? TopVectorIcon : LeftVectorIcon
  const effectiveOverlay = overlayColor ?? '#ffffff'

  useEffect(() => {
    if (textInView) {
      controls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 1, delay: 0.2 },
      })
    }
  }, [controls, textInView])

  useEffect(() => {
    if (paraInView) {
      paraControls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 1, delay: 0.4 },
      })
    }
  }, [paraControls, paraInView])

  useEffect(() => {
    if (buttonInView) {
      buttonControls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 1, delay: 0.6 },
      })
    }
  }, [buttonControls, buttonInView])

  if (isLoading) {
    return (
      <div className="flex space-x-2 justify-center items-center bg-white h-screen">
        <span className="sr-only">Loading...</span>
        <div className="h-8 w-8 bg-[#2b364b] rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="h-8 w-8 bg-[#2b364b] rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div className="h-8 w-8 bg-[#2b364b] rounded-full animate-bounce"></div>
      </div>
    )
  }

  const handleRedirect = url => {
    const formattedUrl = url?.startsWith('http') ? url : `http://${url}`
    window.open(formattedUrl, '_blank')
  }

  return (
    <div
      className={`relative h-[212.131px] sm:h-[422px] lg:h-[701px] overflow-hidden`}
    >
      {/* pointer-events-none so focal drag hits .main below; button opt-in via pointer-events-auto */}
      <div className={`relative z-10 pointer-events-none`}>
        <img
          src={vectorSrc}
          alt=""
          aria-hidden
          className={`pointer-events-none absolute ${
            position === 'justify-start' &&
            'top-[-190px] left-[-110px] sm:left-[-150px] sm:top-[-380px] md:left-[-300px] lg:top-[-550px]  lg:left-[-200px]'
          } 
          ${
            position === 'justify-end' &&
            'top-[-190px] -rotate-180 right-[-110px] sm:right-[-150px] sm:top-[-380px] md:right-[-300px] lg:top-[-550px]  lg:right-[-200px]'
          }
          ${
            position === 'justify-center' &&
            'top-[-225px] sm:top-[-520px] md:top-[-500px]  lg:top-[-700px] left-[50%] transform translate-x-[-50%]'
          } w-[500px] h-[600px] md:w-[1100px]  sm:h-[1200px] lg:w-[1144px] lg:h-[1813.066px]`}
        />
        <div
          className={`pointer-events-none flex h-[100%] w-full items-center ${position}`}
        >
          <div
            className={`pointer-events-none w-[130px] sm:!w-[248.273px] lg:!w-[412px] h-[141px] md:min-h-[100px] lg:min-h-[269px] ${
              position === 'justify-start' && 'text-start'
            } ${position === 'justify-center' && 'text-center'} ${
              position === 'justify-end' && 'text-end'
            }  absolute  ${
              position === 'justify-end'
                ? 'right-[20px] md:right-[50px] lg:right-[80px] top-[40px] sm:top-[140px] md:top-[130px] lg:top-[140px]  md:mx-2 lg:mx-20'
                : position === 'justify-start'
                ? 'left-[20px] md:left-[50px] lg:left-[80px] top-[40px] sm:top-[140px] md:top-[130px] lg:top-[140px]   md:mx-2 lg:mx-20'
                : position === 'justify-center'
                ? 'top-[15px] sm:top-[10px] md:top-[40px]  lg:top-[-10px] h-[141px] md:min-h-[100px] lg:min-h-[269px] !w-[160px] sm:!w-[140px] md:!w-[248.273px] lg:!w-[480px]'
                : ''
            }  h-auto `}
          >
            <motion.h1
              ref={textRef}
              initial={{ opacity: 0, y: 50 }}
              animate={controls}
              className={`context_text w-full h-auto max-h-[180px] ${
                position === 'justify-center' &&
                'text-[16px] sm:text-[18px] lg:text-[64px]'
              } text-[16px] sm:text-[18px] lg:text-[64px]`}
            >
              {bannerItem?.contentHead}
            </motion.h1>
            <motion.h1
              ref={textRef}
              initial={{ opacity: 0, y: 50 }}
              animate={controls}
              className={`video_content_para  w-full   ${
                position === 'justify-center' &&
                '!text-[10px] md:!text-[12px] lg:!text-[14px] w-full sm:w-[140px] md:!w-[130px] lg:!w-[250px] xl:!w-[280px] mx-auto 2xl:!w-[412px]'
              }  mt-[5px] h-[40px] sm:h-[40px] md:h-[58px] text-[10px] md:!text-[14px]`}
            >
              {bannerItem?.contentDescription}
            </motion.h1>
            <motion.div
              className={`pointer-events-auto flex ${
                position === 'justify-start' && 'justify-start'
              } ${
                position === 'justify-center' && 'justify-center'
              } ${
                position === 'justify-end' && 'justify-end'
              }  items-center`}
              ref={buttonRef}
              initial={{ opacity: 0, y: 50 }}
              animate={buttonControls}
            >
              <Button
                onClick={() => handleRedirect(bannerItem?.btnUrl)}
                type={'submit'}
                className={`hero-section-save-btn cursor-pointer !w-[80px]  !text-[8px] md:!text-[10px] lg:!text-[16px] sm:!w-[100px] md:!w-[120px] lg:!w-[185px] !h-[30px] md:!h-[40px] lg:!h-[56px] ${
                  position === 'justify-center'
                    ? '!text-[8px] md:!text-[10px] lg:!text-[16px] lg:!mt-[15px] mt-2'
                    : 'text-[20px] mt-2 lg:mt-[45px]'
                }  mt-10 bg-[#2b364b] rounded-full border-none text-[#fff]`}
              >
                <span className="banner_btn">{bannerItem?.contentBtn}</span>
              </Button>
            </motion.div>
          </div>
        </div>
      </div>

      <div
        className={`main absolute inset-0 z-0 overflow-hidden select-none ${focalPanHandlers ? 'touch-none' : ''} ${
          focalPanHandlers
            ? focalPanDragging
              ? 'cursor-grabbing'
              : 'cursor-grab'
            : ''
        }`}
        {...(focalPanHandlers || {})}
      >
        {videoUrl && (
          <video
            className={`h-full w-full ${focalPanHandlers ? 'pointer-events-none' : ''}`}
            style={{
              objectFit: imageObjectFit,
              objectPosition: imageObjectPosition,
            }}
            src={videoUrl || bannerItem?.video}
            autoPlay
            loop
            muted
            playsInline
          />
        )}

        {imageUrl && (
          <img
            alt="banner_image"
            src={imageUrl || bannerItem?.image}
            draggable={false}
            className={`h-full w-full ${
              focalPanHandlers ? 'pointer-events-none' : ''
            }`}
            style={{
              objectFit: imageObjectFit,
              objectPosition: imageObjectPosition,
            }}
          />
        )}
      </div>
      <div
        style={{ background: effectiveOverlay }}
        className={`content pointer-events-none absolute z-[5] opacity-45 top-0 left-0 h-full w-full`}
      ></div>
    </div>
  )
}
